import React from 'react'
import './Reviews.css'
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper/modules'; 
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStar } from "@fortawesome/free-solid-svg-icons";
import 'swiper/css';
import 'swiper/css/pagination';
const Reviews = () => {
  return (
    <div className='reviews mb-5'>
      <div className="text-center mb-3 pt-4">
        <img src="images/Group 79.png" alt="" />
      </div>
        <div className="container">
        <Swiper
       className=' pb-4'
      modules={[ Pagination]} 
      pagination={{ clickable: true,el: ".custom-pagination-2", }} 
      spaceBetween={170} 
      breakpoints={{
    768: {
      slidesPerView: 1,
    },
    1024: {
      slidesPerView: 2,
    },
  }}
      loop
    >
        <SwiperSlide>
          <div className="card bg-transparent rounded-5 border-0 h-100 position-relative">
            <div className="review-card rounded-5 p-3 h-100">
                <div className="d-flex align-items-center gap-3 mb-4">
                    <img src="images/man.png" style={{width:"54px"}} alt="" />
                    <h4 className='m-0 main-color'>Lorem Ipsum</h4>
                </div>
                <p className="review-text mb-4">Lorem Ipsum is simply dummy text Lorem Ipsum is simply dummy text</p>
                <div className="d-flex justify-content-between">
                    <div className="d-flex">
                        <FontAwesomeIcon icon={faStar} className="text-warning"/>
                        <FontAwesomeIcon icon={faStar} className="text-warning"/>
                        <FontAwesomeIcon icon={faStar} className="text-warning"/>
                        <FontAwesomeIcon icon={faStar} className="text-warning"/>
                        <FontAwesomeIcon icon={faStar} className="text-warning"/>
                    </div>
                    <div className='d-flex'>
                        <p className="text-dark m-0">3.5k</p>
                        <img src="images/plant.png" alt="" />
                    </div>
                </div>
            </div>
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div className="card bg-transparent rounded-5 border-0 h-100 position-relative">
            <div className="review-card rounded-5 p-3 h-100">
                <div className="d-flex align-items-center gap-3 mb-4">
                    <img src="images/man.png" style={{width:"54px"}} alt="" />
                    <h4 className='m-0 main-color'>Lorem Ipsum</h4>
                </div>
                <p className="review-text mb-4">Lorem Ipsum is simply dummy text Lorem Ipsum is simply dummy text</p>
                <div className="d-flex justify-content-between">
                    <div className="d-flex">
                        <FontAwesomeIcon icon={faStar} className="text-warning"/>
                        <FontAwesomeIcon icon={faStar} className="text-warning"/>
                        <FontAwesomeIcon icon={faStar} className="text-warning"/>
                        <FontAwesomeIcon icon={faStar} className="text-warning"/>
                        <FontAwesomeIcon icon={faStar} className="text-warning"/>
                    </div>
                    <div className='d-flex'>
                        <p className="text-dark m-0">3.5k</p>
                        <img src="images/plant.png" alt="" />
                    </div>
                </div>
            </div>
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div className="card bg-transparent rounded-5 border-0 h-100 position-relative">
            <div className="review-card rounded-5 p-3 h-100">
                <div className="d-flex align-items-center gap-3 mb-4">
                    <img src="images/man.png" style={{width:"54px"}} alt="" />
                    <h4 className='m-0 main-color'>Lorem Ipsum</h4>
                </div>
                <p className="review-text mb-4">Lorem Ipsum is simply dummy text Lorem Ipsum is simply dummy text</p>
                <div className="d-flex justify-content-between">
                    <div className="d-flex">
                        <FontAwesomeIcon icon={faStar} className="text-warning"/>
                        <FontAwesomeIcon icon={faStar} className="text-warning"/>
                        <FontAwesomeIcon icon={faStar} className="text-warning"/>
                        <FontAwesomeIcon icon={faStar} className="text-warning"/>
                        <FontAwesomeIcon icon={faStar} className="text-warning"/>
                    </div>
                    <div className='d-flex'>
                        <p className="text-dark m-0">3.5k</p>
                        <img src="images/plant.png" alt="" />
                    </div>
                </div>
            </div>
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div className="card bg-transparent rounded-5 border-0 h-100 position-relative">
            <div className="review-card rounded-5 p-3 h-100">
                <div className="d-flex align-items-center gap-3 mb-4">
                    <img src="images/man.png" style={{width:"54px"}} alt="" />
                    <h4 className='m-0 main-color'>Lorem Ipsum</h4>
                </div>
                <p className="review-text mb-4">Lorem Ipsum is simply dummy text Lorem Ipsum is simply dummy text</p>
                <div className="d-flex justify-content-between">
                    <div className="d-flex">
                        <FontAwesomeIcon icon={faStar} className="text-warning"/>
                        <FontAwesomeIcon icon={faStar} className="text-warning"/>
                        <FontAwesomeIcon icon={faStar} className="text-warning"/>
                        <FontAwesomeIcon icon={faStar} className="text-warning"/>
                        <FontAwesomeIcon icon={faStar} className="text-warning"/>
                    </div>
                    <div className='d-flex'>
                        <p className="text-dark m-0">3.5k</p>
                        <img src="images/plant.png" alt="" />
                    </div>
                </div>
            </div>
          </div>
        </SwiperSlide>
    </Swiper>
    <div className="custom-pagination-2"></div>
        </div>
    </div>
  )
}

export default Reviews
